module.exports = __webpack_public_path__ + "img/744.4a856d74.jpg";